// contacts/actionCreators.js

import actionTypes from './actionTypes';

//public actions
const requestAllContactsData = () => ({
    type: actionTypes.REQUEST_CONTACTS_DATA
});

const contactsDataResponse = (success, contactsData, errors) => ({
    type: actionTypes.CONTACTS_DATA_RESPONSE,
    payload: {
        success: success,
        contacts: contactsData.data,
        errors: errors
    }
});

export default {
    requestAllContactsData,
    contactsDataResponse
};